<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<ng-container *ngIf="isTaskCommentsLoading else loading">
    <div class="comments_container">
        @if (!taskCommentsData.length) {
            <b>{{ 'EMPTY_LISTS.COMMENTS' | translate }}</b>
        } @else {
            @for (item of taskCommentsData; track item.id; let i = $index) {
                <div [attr.data-member-index-in-comments]="i"
                     [class.my]="item.member_guid === currentUser.guid"
                     [class.other]="item.member_guid !== currentUser.guid"
                     class="comments"
                >

                    <app-avatar *ngIf="item.user"
                                [profile]="item.user"
                                [size]="'medium'"
                    ></app-avatar>

                    <div class="message"
                         [class.my]="item.member_guid === currentUser.guid"
                    >
                        @for (comment of item.comments; let ic = $index; track comment.id) {
                            <div [attr.data-comment-index]="ic"
                                 class="comment_body mb-2"
                            >
                                <div class="comment_text"
                                     [class.my]="item.member_guid === currentUser.guid"
                                     [class.other]="item.member_guid !== currentUser.guid"
                                     [innerHTML]="comment.comment"
                                     data-context="commentText"
                                ></div>
                                <div class="meta_info"
                                     [class.my]="item.member_guid === currentUser.guid"
                                >
                                <span class="comment_buttons"
                                      *ngIf="item.member_guid === currentUser.guid"
                                >
                                    <lucide-icon name="pencil-line"
                                                 size="16"
                                                 (click)="setComment(comment)"
                                                 data-action="editComment"
                                    ></lucide-icon>
                                    <lucide-icon class="mx-1"
                                                 (click)="deleteComment(comment)"
                                                 size="16"
                                                 data-action="deleteComment"
                                                 name="trash-2"
                                    ></lucide-icon>
                                </span>
                                    <small>{{ helper.chatDate(comment.created_at) }}</small>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        }
    </div>
</ng-container>

<div *ngIf="canCreateComments"
     class="add__comment">
    <h3>{{ 'TASKS.TEXT.ADD_COMMENT' | translate }}:</h3>
    <app-component-ckeditor (emitFinish)="newComment = $event[1]"
                            [inputData]="comment"
                            [isShowButtons]="false"
                            [isShowEditor]="isShowEditor"
                            data-action="addComment">
    </app-component-ckeditor>

    <button (click)="sendComment()"
            *ngIf="!isEditComment"
            [disabled]="!newComment || isLockButton"
            class="btn {{isShowEditor ? 'btn-primary':'btn-info'}}"
            data-action="sendComment"
            style="margin-top: 10px; z-index: 1002;">
        <i class="bi bi-plus"></i>
        <span *ngIf="!isLockButton else loading">{{ 'TASKS.BUTTONS.ADD_COMMENT' | translate }}</span>
    </button>

    <div *ngIf="isEditComment"
         class="btn-group"
         style="margin-top: 10px; z-index: 1002">
        <button (click)="editComment()"
                [disabled]="!newComment || isLockButton"
                class="btn btn-primary"
                data-action="editCommentButton">
            <span *ngIf="!isLockButton else loading">{{ 'TASKS.BUTTONS.EDIT_COMMENT' | translate }}</span>
        </button>
        <button (click)="isEditComment = false; isShowEditor = false; comment = ' '"
                class="btn btn-primary"
                data-action="cancelButton"
                style="margin-left: 10px;">
            <span>{{ 'TASKS.BUTTONS.CANCEL' | translate }}</span>
        </button>
    </div>
</div>
